module.exports = __webpack_public_path__ + "static/BannerHero2x-9159cc4a1cb25fd795f45e1ed15e1c0e.jpg";